const points = [28, 35, 32, 47, 44, 59, 55, 72, 68, 84, 78, 92];

export function LineChart() {
  const path = points.map((point, index) => `${index === 0 ? "M" : "L"} ${index * 54 + 12} ${120 - point}`).join(" ");
  const area = `${path} L ${11 * 54 + 12} 120 L 12 120 Z`;

  return (
    <div className="relative h-52 w-full overflow-hidden rounded-2xl bg-gradient-to-b from-brand-50/60 to-white p-4">
      <svg viewBox="0 0 620 140" className="h-full w-full" preserveAspectRatio="none" role="img" aria-label="Grafik performa website">
        <defs>
          <linearGradient id="chart-fill" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#19b963" stopOpacity="0.28" />
            <stop offset="1" stopColor="#19b963" stopOpacity="0.01" />
          </linearGradient>
        </defs>
        {[20, 50, 80, 110].map((y) => <line key={y} x1="0" x2="620" y1={y} y2={y} stroke="#dce8df" strokeDasharray="4 5" />)}
        <path d={area} fill="url(#chart-fill)" />
        <path d={path} fill="none" stroke="#0d944d" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
        {points.map((point, index) => <circle key={`${point}-${index}`} cx={index * 54 + 12} cy={120 - point} r="4" fill="#fff" stroke="#0d944d" strokeWidth="3" />)}
      </svg>
      <div className="absolute inset-x-5 bottom-2 flex justify-between text-[10px] font-semibold text-slate-400">
        <span>Jan</span><span>Mar</span><span>Mei</span><span>Jul</span><span>Sep</span><span>Nov</span>
      </div>
    </div>
  );
}
